/**
 * Created by TY-xie on 2018/4/2.
 */
import axios from "axios";
import { Toast } from "vant";
import * as utils from "@/utils";

const { bid } = utils.param2Obj(location.href);
// 请求之前的拦截器
axios.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// 请求之后的拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.status === 300) {
      window.location.href = "https://h5.yunhuiyuan.cn/429.html";
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const dftOpt = {
  isSuccess: (res) => res.data.resultCode === 200,
  message: (res) => res.data.msg || res.data.message || "",
  toast: true,
  loading: true,
};

export default function request(
  { method = "post", data, url, headers = {} },
  opt = {}
) {
  opt = { ...dftOpt, ...opt };
  return new Promise((resolve, reject) => {
    opt.loading && Toast.loading({ message: "加载中...", duration: 0 });
    let params = { bid };
    if (data.params) {
      params = data.params;
      delete data.params;
    }
    if (!params.bid) {
      params.bid = bid;
    }
    axios({
      method,
      url,
      data,
      params,
      headers: {
        ...headers,
        bid,
      },
    })
      .then((res) => {
        opt.loading && Toast.clear();
        if (!opt.isSuccess(res)) {
          console.log("should toast ? ");
          if (opt.toast) {
            console.log("should toast !", res.data.message);
            Toast.fail(opt.message(res) || "后端操作失败!");
          }
          console.log(res);

          resolve({
            success: false,
            message: opt.message(res) || "后端操作失败!",
            data: res.data, // 后端操作失败返回完整res
            res: res.data,
          });
        } else {
          resolve({
            success: true,
            message: opt.message(res) || "请求成功!",
            data: res.data.data || res.data,
            res: res.data,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        opt.loading && Toast.clear();
        Toast.fail("网络故障");
        resolve({
          success: false,
          message: "网络故障",
          data: err,
          res: {},
        });
      });
  });
}
